import { mapGetters, mapState } from 'vuex'
import util from '@/util'

export default {
  name: 'CarrinhoCompras',
  computed: {
    ...mapGetters('carrinho', ['obterTotalItensCarrinho', 'possuiItensCarrinho']),
    ...mapState('auth', ['regrasLogin']),
    temPagamentoPendente () {
      if (util.valorVazio(this.regrasLogin)) {
        return false
      }
      const pendenciasDeLogin = JSON.parse(this.regrasLogin)
      if (util.valorVazio(pendenciasDeLogin.pagamentoPendente)) {
        return false
      }
      return pendenciasDeLogin.pagamentoPendente
    }
  },
  methods: {
    totalItens () {
      const totalItensCarrinho = this.obterTotalItensCarrinho
      const limiteMax = 99
      return totalItensCarrinho >= limiteMax ? `${limiteMax}+` : totalItensCarrinho
    }
  }
}
